// extracted by mini-css-extract-plugin
module.exports = {"filling-bottle":"FillingBottle_filling-bottle__2aTEX","spin":"FillingBottle_spin__2l__A","fill":"FillingBottle_fill__2dljr"};